<template>
  <div>
    <v-menu offset-y open-on-hover offset-overflow>
      <template v-slot:activator="{ on }">
        <v-toolbar-title v-on="on">
          <span>
            <flag :iso="$i18n.locale() == 'en' ? 'gb' : $i18n.locale()" class="mr-2" />
            {{ $i18n.locale().toUpperCase() }}
          </span>
        </v-toolbar-title>
      </template>
      <v-list>
        <v-list-tile
          v-for="(item, index) in langOptions"
          :key="index"
          @click="onChangeLang(item.value)"
        >
          <v-list-tile-title class="primary-color">
            <flag :iso="item.flag" class="mr-2"></flag>
            {{ item.value.toUpperCase() }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: function () {
    return {
      langOptions: [
        {
          value: 'en',
          flag: 'gb',
        },
        {
          value: 'th',
          flag: 'th',
        },
        // {
        //   value: 'la',
        //   flag: 'la'
        // }
      ],
    }
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang',
    }),
  },
  mounted: function () {
    var vm = this
  },
  methods: {
    onChangeLang: function (lang) {
      if (['en', 'th', 'la'].includes(lang)) {
        location.href = this.$route.fullPath.replace('/' + this.currentLang + '/', '/' + lang + '/')
      }
    },
  },
}
</script>

<style scoped>
.z-dropdown .dropdown-content {
  transform-origin: 0px 0px;
  opacity: 1;
  transform: scaleX(1) scaleY(1);
}
</style>


// WEBPACK FOOTER //
// src/components/elements/LangDropdown.vue